import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConstantsCLA } from '../../../shared/constants-cla';
import {
  EsitoTest,
  PercentualiStudio,
  ProveEsamiDisponibiliDTO,
} from '../../../model/newModel';
import {
  GetProveEsamiDisponibiliCommand,
  AddUpdatePrenotatiProvaFinaleCommand,
  EsitoTestCommand,
  GetCommand,
} from 'src/app/model/command-model';
import {
  PercentualiStudioCommand,
  AbilitaDisabilitaCommand,
} from '../../../model/command-model';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private http: HttpClient) {}

  esitoPlacementTest(idStudente: number) {
    const command = new EsitoTestCommand();
    command.idStudente = idStudente;

    return this.http.post<EsitoTest>(
      ConstantsCLA.ESITO_PLACEMENT_TEST_URL,
      command
    );
  }

  percentualiStudio(idStudente: number) {
    const command = new PercentualiStudioCommand();
    command.idStudente = idStudente;
    return this.http.post<PercentualiStudio>(
      ConstantsCLA.PERCENTUALI_STUDIO_URL,
      command
    );
  }

  abilitaOraleFacoltativo(idStudente: number, value: boolean) {
    const command = new AbilitaDisabilitaCommand();
    command.id = idStudente;
    command.active = value;
    return this.http.post<Boolean>(
      ConstantsCLA.ABILITA_ORALE_FACOLTATIVO_STUDENTE_URL,
      command
    );
  }

  getFileAgendaStudioStudente(id: number): Observable<any> {
    const command = new GetCommand();
    command.id = id;
    return this.http.post(
      ConstantsCLA.GET_AGENDA_STUDIO_STUDENTE_URL,
      command,
      { responseType: 'blob' as 'json' }
    );
  }

  getProveEsamiDisponibili(command: GetProveEsamiDisponibiliCommand) {
    return this.http.post<ProveEsamiDisponibiliDTO>(
      ConstantsCLA.PROVE_ESAMI_DISPONIBILI,
      command
    );
  }

  prenotazioneProvaFinale(command: AddUpdatePrenotatiProvaFinaleCommand) {
    return this.http.post<Boolean>(
      ConstantsCLA.ADD_PRENOTAZIONE_PROVA_FINALE,
      command
    );
  }
}
